import { BCNotification } from '@bimser/components';
import { ErrorCodes, ErrorInfo, MessageBox } from '../..';

export function notifyError(e: ErrorInfo) {
	const exceptionData = e?.exception?.data;
	let errorCode: string = 'STD.ERROR_000';
	if (exceptionData?.exception) {
		errorCode = getTaleException(exceptionData.exception);
	}
	const message = ErrorCodes[errorCode];
	if (message) {
		BCNotification.error({ message });
	} else {
		MessageBox.error({ error: exceptionData });
	}
}

export const customErrorHandler = (e: ErrorInfo) =>
	function* () {
		notifyError(e);
	};

export const customErrorHandlerWithThrow = (e: ErrorInfo) =>
	function* () {
		notifyError(e);
		throw e;
	};

export function getTaleException(e: any, getLastExceptionDetails?: boolean) {
	if (e?.InnerException) {
		return getTaleException(e?.InnerException, getLastExceptionDetails);
	} else if (e?.ExternalException) {
		return getTaleException(e?.ExternalException, getLastExceptionDetails);
	}
	return getLastExceptionDetails ? e : e['Code'];
}
